import React, { useEffect, useState } from 'react'
import { DeckState, generateInitialDeckState } from 'redux/deck/initialState'

import { generateTabState } from 'types/searchV2'

import DeckService from 'services/deck.service'
import ToastService from 'services/toast.service'

import Tab from 'components/cardSearchPanel/tabs/tab'
import LineLoader from 'components/elements/LineLoader'
import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'

import { dateAdded } from 'redux/deck/helpers/sorting'
import { deckResponseToDeckState } from 'utils/responseToDeck'

import styles from './packageDetailsOverlay.module.scss'

type Props = {
  deckId: number | null
  onClose: () => void
  onDragStart?: () => void
  onDragStop?: () => void
}

const PackageDetailsOverlay = ({ deckId, onClose, onDragStart, onDragStop }: Props) => {
  const [loading, setLoading] = useState(false)

  const [tab, _setTab] = useState(generateTabState.other())
  const [deck, setDeck] = useState<DeckState>()

  useEffect(() => {
    if (!deckId) return

    setLoading(true)

    DeckService.details(deckId)
      .then(res => {
        const cleanDeckState = generateInitialDeckState()
        const deck = deckResponseToDeckState(cleanDeckState, res, true)

        setDeck(deck)
      })
      .catch(() => ToastService.create('Failed to package details', 'Card packages'))
      .finally(() => setLoading(false))
  }, [deckId])

  const cards = Object.values(deck?.cardMap || {}).sort(dateAdded)

  return (
    <GlobalOverlayStack open={!!deckId} onClose={onClose} className={styles.container}>
      {loading && <LineLoader />}

      <div className={styles.controls}>
        <h3>{deck?.name}</h3>
      </div>

      <Tab
        tab={tab}
        initailResults={cards}
        onTabUpdate={() => null}
        onDragStart={onDragStart}
        onDragStop={onDragStop}
        active
      />
    </GlobalOverlayStack>
  )
}

export default PackageDetailsOverlay
